<template>
	<div class="field-container">
		<label class="label" for="tag">
			{{ label }}
			<span v-if="required" class="require">*</span>
		</label>
		<input
			:class="{ 'field-error': error }"
			:value="modelValue"
			:type="type"
			:placeholder="placeholder"
			required
			:style="`width: ${width}; height: ${height}`"
			:readonly="readonly"
			:autocomplete="autocomplete"
			@input="handleInput"
			@blur="handleBlur"
		/>
		<img
			v-if="type == 'password'"
			src="~/assets/icons/password-display.svg?url"
			class="field-image"
			@click="showPassword"
		/>
		<img
			v-else
			src="~/assets/icons/password-eye-open.svg?url"
			class="field-image"
			@click="showPassword"
		/>
		<div class="container-error">
			<span v-show="error" class="error-message">
				{{ error }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InputTypePassword',

	props: {
		label: {
			type: String,
			default: '',
		},
		modelValue: {
			type: String,
			default: '',
		},
		error: {
			type: String,
			default: '',
		},
		readonly: {
			type: Boolean,
			default: false,
		},
		autocomplete: {
			type: String,
			default: 'on',
		},
		required: Boolean,
		placeholder: {
			type: String,
			default: '',
		},
		width: {
			type: String,
			default: '',
		},
		height: {
			type: String,
			default: '',
		},
	},

	emits: ['update:modelValue', 'blur'],

	data() {
		return {
			content: this.modelValue,
			type: 'password',
		}
	},

	methods: {
		handleInput(e) {
			this.$emit('update:modelValue', e.target.value)
		},
		handleBlur(e) {
			this.$emit('blur', e.target.value)
		},

		showPassword() {
			this.type = this.type === 'password' ? 'text' : 'password'
		},
	},
}
</script>

<style scoped>
.field-container {
	display: flex;
	flex-direction: column;
	margin-bottom: 18px;
}

input {
	min-width: 188px;
	max-height: 39px;
	outline: none;
	border: none;
	background: #ffffff;
	border: 1px solid #d8d8d8;
	border-radius: 5px;
	padding: 10px;
	margin-bottom: 0px;
}

input:read-only {
	color: #999999;
}

.field {
	background: #ffffff;
	box-shadow: 0px 0px 10px rgba(50, 50, 71, 0.2);
	border-radius: 8px;
	height: 39px;
	margin-bottom: 0px;
	border: none;
}

label {
	font-size: 16px;
	font-weight: 500;
	color: black;
	text-transform: none;
	margin-bottom: 10px;
}

.field-error {
	border: 1px solid red !important;
}

.error-message {
	font-size: 12px;
	color: red;
	margin-left: auto;
}

.require {
	color: #b2b2b2;
}

.container-error {
	display: flex;
	width: inherit;
}

.field-image {
	width: 18px;
	height: 18px;
	align-self: end;
	margin-top: -27px;
	margin-right: 10px;
	margin-bottom: 10px;
}
</style>
